import { useEffect } from 'react';

export default function useViewport() {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    let timer: ReturnType<typeof setTimeout>;
    let baseline = window.innerHeight, baselineWidth = window.innerWidth;
    const editing = () => document.activeElement instanceof HTMLElement && document.activeElement.matches('input:not([type=checkbox]):not([type=radio]), textarea, [contenteditable=true]');
    const reveal = () => {
      if (window.innerWidth > 768 || !editing() || (viewport?.scale || 1) !== 1) return;
      const el = document.activeElement as HTMLElement;
      const bounds = el.getBoundingClientRect();
      const top = viewport?.offsetTop || 0, height = viewport?.height || window.innerHeight;
      if (bounds.bottom > top + height - 64 || bounds.top < top + 64) el.scrollIntoView({ block: 'center', behavior: 'auto' });
    };
    const update = () => {
      const height = viewport?.height || window.innerHeight;
      if (!editing() || baselineWidth !== window.innerWidth) baseline = window.innerHeight;
      else baseline = Math.max(baseline, window.innerHeight);
      baselineWidth = window.innerWidth;
      root.style.setProperty('--visual-height', `${height}px`);
      root.style.setProperty('--visual-top', `${viewport?.offsetTop || 0}px`);
      root.dataset.keyboard = String(window.innerWidth <= 768 && editing() && (viewport?.scale || 1) === 1 && baseline - height > 120);
      clearTimeout(timer); timer = setTimeout(reveal, 100);
    };
    update();
    viewport?.addEventListener('resize', update);
    const pan = () => root.style.setProperty('--visual-top', `${viewport?.offsetTop || 0}px`);
    viewport?.addEventListener('scroll', pan);
    window.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      clearTimeout(timer); viewport?.removeEventListener('resize', update); viewport?.removeEventListener('scroll', pan);
      window.removeEventListener('resize', update); document.removeEventListener('focusin', update); document.removeEventListener('focusout', update);
      root.style.removeProperty('--visual-height'); root.style.removeProperty('--visual-top'); delete root.dataset.keyboard;
    };
  }, []);
}
